<script>
  import { onMount } from "svelte";
  import { push } from "svelte-spa-router";
  import { sentmsg, entry } from "../stores.js";

  onMount(async () => {
    window.scroll(0, 0);
    if (!$entry || !$entry.complete) {
      push("/");
    }
  });
</script>

<style>
  h6, ul {
    margin-block-start: 0.25rem;
    font-weight: 400;
  }
</style>

<h2>{$sentmsg.header}</h2>
{#each $sentmsg.body.lines as line}
<p class="ws-pl">{line}</p>
{/each}
<h6>{$sentmsg.mailnotice.header}</h6>
<ul>
{#each $sentmsg.mailnotice.items as item}
  <li>{item}</li>
{/each}
</ul>
